export default __webpack_public_path__ + "static/article-ldb-placeholder-e7602d999c53003fcda3f3ddb6531e99.jpg";